import styled from 'styled-components';

export const AssociateHandlerFormStyle = styled.div`
.fkTuFL .rt-tbody .rt-td{
  display: flex;
  justify-content: center;
  align-items: center;
}

.associate-handler-button{
  margin-left: 5px;
}

.associate-handler-body-buttons{
  margin: 30px 0 -38px 45px;
  z-index: 99;
  position: relative;
  width: 510px;
}

.associate-handler-body{
  max-width: 1200px;
  margin: auto;
}

.associate-handler-add-handler-body{
  margin-bottom: 300px;
}

  @media only screen and (max-width:1899px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 553px;
    }
  }
  @media only screen and (min-width:1900px) and (max-width:1915px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 665px;
    }
  }

  @media only screen and (min-width:1916px) and (max-width:2135px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 665px;
    }
  }

  @media only screen and (min-width:2136px) and (max-width:2200px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 765px;
    }
  }

  @media only screen and (min-width:2201px) and (max-width:2400px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 875px;
    }
  }

  @media only screen and (min-width:2401px) and (max-width:2800px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 985px;
    }
  }

  @media only screen and (min-width:2801px) and (max-width:2900px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1095px;
    }
  }

  @media only screen and (min-width:2901px) and (max-width:3200px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1195px;
    }
  }

  @media only screen and (min-width:3201px) and (max-width:3900px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1500px;
    }
  }

  @media only screen and (min-width:3901px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 2410px;
    }
`;
